<style>
</style>

<template>
  <div>
    <div class="card">
      <div class="pl-4 card-header d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Staff Users</h5>

        <router-link to="/userAccess/users/add" class="btn btn-primary"
          v-has-permissions="[PERMISSIONS.WRITE_STAFF]">
          <i class="nav-icon icon-plus"></i>&nbsp;
          Add Staff User
        </router-link>
      </div>

      <div class="card-body" v-if="fetchingStaffUsers || !staffUsers || !staffUsers.length">
        <Loader :size="90" v-if="fetchingStaffUsers" />

        <div class="text-center" v-else-if="!staffUsers">
          Failed to fetch admin users
        </div>

        <div class="text-center" v-else-if="!staffUsers.length">
          No admin users found
        </div>
      </div>

      <table v-else class="table table-stripped" style="border-top: none !important">
        <thead>
          <tr>
            <th class="pl-4">User</th>
            <th>Email</th>
            <th class="text-center">Role</th>
            <th class="text-center"
              v-has-permissions="[PERMISSIONS.APPROVE_STAFF]">Status</th>
            <th class="text-center" v-has-permissions="[PERMISSIONS.WRITE_STAFF]">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in staffUsers" :key="index">
            <td class="pl-4">{{ user.displayName }}</td>
            <td>{{ user.email }}</td>
            <td class="text-center">
              {{ user.userRole ? user.userRole.name : 'No role' }}
            </td>
            <td class="text-center"
              v-has-permissions="[PERMISSIONS.APPROVE_STAFF]">
              <button @click="approveStaffUser(user._id)"
                class="btn btn-sm btn-primary" style="flex-shrink: 0"
                :disabled="user.approving"
                v-if="!user.staffApprovalStatus">
                Approve Staff
              </button>

              <span v-else class="btn btn-sm btn-light">
                <i class="fa fa-check"></i>&nbsp; Approved
              </span>

              <template v-if="user.approving">
                &nbsp;&nbsp;
                <Loader class="d-inline" :size="30" nopad/>
              </template>
            </td>

            <td class="text-center" v-has-permissions="[PERMISSIONS.WRITE_STAFF]">
              <router-link class="btn btn-sm btn-outline-primary" :to="`/userAccess/users/${user._id}/edit`"
                v-has-permissions="[PERMISSIONS.WRITE_STAFF]">
                <i class="fa fa-edit"></i>&nbsp; Edit Details
              </router-link>
              &nbsp;&nbsp;
              <button @click="resetStaffUserPassword(user._id)"
                class="btn btn-sm btn-outline-dark" style="flex-shrink: 0"
                :disabled="user.resettingPassword"
                v-has-permissions="[PERMISSIONS.WRITE_STAFF]">
                <i class="fa fa-lock"></i>&nbsp; Reset Password
              </button>

              &nbsp;&nbsp;
              <Loader class="d-inline" :size="30" nopad
                v-if="user.resettingPassword" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { PERMISSIONS } from '@/permissions';

  export default {
    name: 'StaffUsers',
    data(){
      return {
        PERMISSIONS
      }
    },
    mounted(){
      if(!this.staffUsers)
        this.$store.dispatch('getStaffUsers');
    },
    computed: {
      ...mapState(['staffUsers', 'fetchingStaffUsers'])
    },
    methods: {
      resetStaffUserPassword(id){
        this.$store.dispatch('resetStaffUserPassword', id);
      },
      approveStaffUser(id){
        this.$store.dispatch('approveStaffUser', id);
      }
    }
  }
</script>
